// ============================================================
// Mock Receipts Data
// ============================================================
// Scoped by schoolId

// Normally, receipts are generated dynamically or fetched from the backend.
// We will store historical receipts here for mock purposes.

export const mockReceipts = {
  'school-1': [
    {
      id: 'rcpt-1',
      receiptNumber: 'RCPT-2026-000001',
      transactionId: 'txn-1',
      studentId: 'STD2024001',
      studentName: 'Alice Wang',
      classId: 'class-5',
      className: 'Grade 5',
      sectionName: 'Section A',
      feeHeadId: 'fee-str-1',
      feeHeadName: 'Tuition Fee',
      amount: 15000,
      paymentMethod: 'UPI',
      collectedBy: 'John Accountant',
      date: '2026-07-10T10:30:00Z',
      amountInWords: 'Fifteen Thousand Only',
      remarks: 'Paid via UPI app',
    },
    {
      id: 'rcpt-2',
      receiptNumber: 'RCPT-2026-000002',
      transactionId: 'txn-2',
      studentId: 'STD2024002',
      studentName: 'Michael Smith',
      classId: 'class-1',
      className: 'Grade 1',
      sectionName: 'Section A',
      feeHeadId: 'fee-str-2',
      feeHeadName: 'Admission Fee',
      amount: 25000,
      paymentMethod: 'Bank Transfer',
      collectedBy: 'System',
      date: '2026-07-12T14:15:00Z',
      amountInWords: 'Twenty Five Thousand Only',
      remarks: 'Online admission payment',
    },
    {
      id: 'rcpt-3',
      receiptNumber: 'RCPT-2026-000003',
      transactionId: 'txn-3',
      studentId: 'STD2024001',
      studentName: 'Alice Wang',
      classId: 'class-5',
      className: 'Grade 5',
      sectionName: 'Section A',
      feeHeadId: 'fee-str-3',
      feeHeadName: 'Transport Fee',
      amount: 3000,
      paymentMethod: 'Cash',
      collectedBy: 'Sarah Reception',
      date: '2026-07-16T09:45:00Z',
      amountInWords: 'Three Thousand Only',
      remarks: 'Cash collected at counter',
    }
  ],
  'school-002': []
};
